import React from "react";
import { Box, Flex, SimpleGrid } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { SubNavLink } from "./sub-nav-link";
import { PlatformTeaser } from "./platform-teaser";
import { type PlatformTabProps } from "./data";
import { SubNavHeaderLink } from "./sub-nav-header-link";

export function PlatformSubNav({ columns, teaser }: PlatformTabProps) {
  const { theme } = useColorTheme();
  const borderColor = `brand.header.border.${theme}`;

  return (
    <Box
      w="100%"
      maxW={{ base: "100%", xl: "container.page" }}
      mt={{ base: "small", lg: "big" }}
      mx="auto"
      px={{ base: 0, xl: "biggest" }}
    >
      <Flex flexDir={{ base: "column", lg: "row" }} flex={1} gap="small" w="100%">
        {columns?.map(({ label, primaryItem, items }, index) => {
          const isDoubleGrid = items && items.length > 4;
          const maxW = isDoubleGrid ? "none" : { base: "none", lg: "300px", xl: "380px" };

          return (
            <Flex
              key={label}
              borderLeft="1px"
              borderBottom="1px"
              borderLeftColor={{ base: "transparent", lg: index === 0 ? "transparent" : borderColor }}
              borderBottomColor={{
                base: index === columns.length - 1 ? "transparent" : borderColor,
                lg: "transparent",
              }}
              direction="column"
              flex={1}
              maxW={maxW}
              pl={{ base: "smaller", lg: "smallest", xl: index === 0 ? "0" : "small" }}
              pr={{ base: "smaller", lg: "0" }}
              pb={{ base: "small", lg: "0" }}
            >
              {primaryItem && <SubNavHeaderLink {...primaryItem} />}

              {items && (
                <SimpleGrid
                  columns={{ base: 1, lg: isDoubleGrid ? 2 : 1 }}
                  columnGap={{ base: "tiny", xl: "small" }}
                  w="100%"
                >
                  {items?.map((navItem) => (
                    <SubNavLink key={navItem.label} aria-label={navItem.label} {...navItem} />
                  ))}
                </SimpleGrid>
              )}
            </Flex>
          );
        })}

        <Flex
          direction="column"
          flex={1}
          pos="relative"
          pb={{ base: "small", lg: "0" }}
          maxW={{ base: "100%", lg: "300px", xl: "330px" }}
        >
          <PlatformTeaser {...teaser} />
        </Flex>
      </Flex>
    </Box>
  );
}
